export const themeColors = {
  positive: '#00b4bc',
  assertive: '#F57170',
  energized: '#364f6b',
  neutral: '#9C9B9B',
  white: '#fff',
  lightblack: '#444',
  darkpositive: '#006c70',
  lightpositive: '#ccf0f1',
  evilred: '#DC143C',
  footergrey: '#efefef',

  //material-ui colors
  primary: '#00BCD4',
  secondary: '#FF4081',

  //amazon color
  amazon: '#FEBD69',

  //#TODO: work on these..
  positiveFont: '#fff',
  lightBackground: '#eee',
}

export const themeSpacing = {
  mainBarHeight: 200,
}

export const toolbarStyles = {
  labelStyle: {
    fontWeight: 500,
    letterSpacing: '0.8px',
    fontSize: '13px',
    textTransform: 'uppercase',
    textDecoration: 'none',
    color: themeColors.neutral,
    paddingLeft: 0,
    paddingRight: '46px',
  },

  labelStyleSmall: {
    fontWeight: 500,
    letterSpacing: '0.8px',
    fontSize: '9px',
    textTransform: 'uppercase',
    textDecoration: 'none',
    color: themeColors.neutral,
    paddingLeft: 0,
    paddingRight: '46px',
  },

  titleStyle: {
    height: 'auto',
    marginRight: '0px',
  },

  activeLabel: {
    color: themeColors.positive,
  },

  dropDownSeparator: {
    //marginTop: '2px',
    color: themeColors.neutral,
    paddingRight: '0px',
  },
  iconStyle: {
    fill: themeColors.positive,
  },
}

export const noResultsStyles = {
  titleStyle: {
    marginTop: '0px',
    marginBottom: '4px',
  },
  iconStyle: {
    color: themeColors.neutral,
    fontSize: '50px',
  },
}

export const searchStyles = {
  clear: {
    color: themeColors.neutral,
    top: '8px',
    cursor: 'pointer',
  },
  input: {
    marginRight: '16px',
  },
}

export const filterStyle = {
  clear: {
    color: themeColors.neutral,
    top: '2px',
    cursor: 'pointer',
  },
  select: {
    width: '100px',
    marginRight: '16px',
  },
}

export const tabStyle = {
  backgroundColor: themeColors.white,
  color: themeColors.positive,
}

//#TODO: work on these.. from swapick cpp
/*

$dark: #444 !default;
$darker: #222 !default;
$light: #fff !default;
$stable: #f5f5f5 !default;
$stabledarker: darken($stable, 5%) !default;
$calm: #8A8780 !default;
$royal: darken(#3F9CBA, 25%) !default;
$facebook: #3b5998;
$amazon: #febd69;

$font-title-family: 'Montserrat', sans-serif;
$font-text-family: 'Istok Web', sans-serif;

*/



// WEBPACK FOOTER //
// ./src/styles/theme.js